import type { FC } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { ContentPoll } from "@/partner/entities/polls";
import { pollPercent } from "../model/contentPollForm";

/** Результаты по вариантам и доля правильных ответов (раскрытая строка). */
export const PollResults: FC<{ poll: ContentPoll }> = ({ poll }) => {
  const { t } = useTranslation();
  const hasCorrect = poll.options.some((option) => option.isCorrect);

  return (
    <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1 }}>
      {poll.options.map((option) => {
        const percent = pollPercent(option.votes, poll.votersCount);
        return (
          <Box key={option.id}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: option.isCorrect ? "success.main" : undefined,
                  fontWeight: option.isCorrect ? 600 : 400,
                }}
              >
                {option.text}
              </Typography>
              <Typography variant="body2">
                {t("polls.results.optionVotes", {
                  count: option.votes,
                  percent,
                })}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={percent}
              color={option.isCorrect ? "success" : "primary"}
            />
          </Box>
        );
      })}
      {hasCorrect && (
        <Typography variant="body2" color="text.secondary">
          {t("polls.results.correctShare", {
            percent: pollPercent(poll.correctVotersCount, poll.votersCount),
          })}
        </Typography>
      )}
    </Box>
  );
};
